<template>
	<div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
        	<div slot="header">
            <i class="fa fa-edit"></i> {{ $t('str.manage-officer') }}
            <div class="card-header-actions">
            	<router-link to="/account/officer" class="card-header-action btn-setting">
			    			<buttons button-type="back"/>
		          </router-link>
            </div>
          </div>
          <b-form @submit.prevent="saveOfficer">
						<b-row>
	            <b-col sm="12">
								<table class="table">
									<tbody>
										<tr>
											<th scope="row">{{$t('str.name')}}</th>
											<td>
												<b-form-input type="text" name="name"
													:class="{ 'form-control':true, 'is-invalid':errors.has('name') }" id="name"
													v-validate="{ required:true }" v-model="addData.name"/>
												<span class="invalid-feedback">{{ errors.first('name') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.email')}}</th>
											<td>
												<b-form-input type="email" name="email"
													:class="{ 'form-control':true, 'is-invalid':errors.has('email') }" id="email"
													v-validate="{ required:true }" v-model="addData.email"/>
	                			<span class="invalid-feedback">{{ errors.first('email') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.password')}}</th>
											<td>
												<b-form-input type="password" name="password"
													:class="{ 'form-control':true, 'is-invalid':errors.has('password') }" id="password"
													v-model="addData.password"/>
												<span class="invalid-feedback">{{ errors.first('password') }}</span>
											</td>
										</tr>
										<tr>
											<th scope="row">{{$t('str.office')}}</th>
											<td>
												<b-input-group>
													<b-form-select name="office_id" v-model="addData.office_id">
														<option :value="null">-</option>
														<option v-for="(cat, i) in officeList" :value="cat.id" :key="i">{{cat.name}}</option>
													</b-form-select>
												</b-input-group>
											</td>
										</tr>
										<tr>
											<th>{{$t('str.suspended')}}</th>
											<td>
												<b-row class="form-group">
													<b-col md="2" cols="2" class="text-right">{{$t('str.yes')}}</b-col>
													<b-col md="1" cols="1">
														<c-switch class="mx-1" color="primary" variant="pill" v-model="temp_is_active"/>
													</b-col>
													<b-col md="2" cols="2">{{$t('str.no')}}</b-col>
												</b-row>
											</td>
										</tr>
									</tbody>
								</table>
	            </b-col>
	          </b-row>
            <b-row>
              <b-col cols="6">
                <buttons button-type="submit"/>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import {Switch as cSwitch} from '@coreui/vue'
import Buttons from '@/views/component/Buttons'

export default {
  components:{
    'buttons':Buttons,
		cSwitch
  },
	data(){
		return {
			id:this.$route.params.id,
			officeList:{},
			addData:{
				name:'',
				email:'',
				password:'',
				office_id:'',
				is_active:0
			},
			temp_is_active:true
		}
	},
	methods:{
		async getAllOffice(){
      this.$auth.checkSession()
  		try{
	  		let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
					headers: {'Authorization':`Bearer ${this.$auth.session.get().passport}`}
				})
				this.officeList = getData.data.data
			}catch(e){
	  		console.log(e.response)
	  	}
		},
		async getOfficer() {
      this.$auth.checkSession()
  		var officerId = this.id

  		if(officerId > 0) {
  			try{
					var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer/${officerId}`, {
						headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
					})

					this.addData.name = getData.data.data.name
					this.addData.email = getData.data.data.email
					this.addData.is_active = getData.data.data.is_active
					this.addData.office_id = getData.data.data.office_id

					/* parsing int to boolean */
					this.temp_is_active = Boolean(getData.data.data.is_active)
			  }catch(e){
			  	console.log('err', e.response)
					if(e.response) {
						this.$router.push('/pages/404')
					}
			  }
			}
		},
  	async saveOfficer() {
      this.$auth.checkSession()
  		if(this.$validator.validateAll()) {
	  		let method = 'post'
	  		let url = `${this.$helper.envi.VUE_APP_API_URL}/Admin/Officer/`

	  		let postData = {
	  			name:this.addData.name,
					email:this.addData.email,
					office_id:this.addData.office_id,
					is_active:this.temp_is_active ? 1 : 0
	  		}
	  		if(this.addData.password != '') {
	  			postData.password = this.addData.password
	  		}

	  		if(this.id > 0) {
	  			method = 'patch'
	  			url = `${url}${this.id}`
	  		}

	  		try {
					let result = await axios[method](url, postData, {
						headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
					})

					this.$toast.success(result.data.meta.message, '', {
		        position:'topCenter'
					})

					if(this.id == 0)
						this.$router.push('/account/officer')
				} catch(e) {
					if(Array.isArray(e.response.data.meta.error)) {
						e.response.data.meta.error.forEach((err) => {
							this.$toast.error(err.msg, e.response.data.meta.message, {
								position:'topCenter'
							})
						})
					} else if(typeof e.response.data.meta.error === 'string') {
						this.$toast.error(e.response.data.meta.message, e.response.data.meta.error, {
							position:'topCenter'
						})
					}
				}
			}
		}
  },
  created(){
		this.getAllOffice()
  	this.getOfficer()
  }
}
</script>